const REACT_APP_BASE_API = process.env.REACT_APP_BASE_API;

const fetchAwsImage = async (imgPath, imageType) => {
    // The token is read on every request. It used to be read once at import, so after a login with
    // no page reload it stayed null and every image went out as "Bearer null".
    const token = localStorage.getItem("token");
    const response = await fetch(`${REACT_APP_BASE_API}/getFileStream?filename=${encodeURIComponent(imgPath)}&imageType=${imageType}`, {
        method: "get",
        headers: {
            "Authorization": `Bearer ${token}`,
        }
    });
    if (!response.ok) {
        throw new Error(`Image request failed with status ${response.status}`);
    }
    const blob = await response.blob();
    return URL.createObjectURL(blob);
}


export {
    fetchAwsImage
};
